import React from "react";
import {
	MdOutlineSmartphone,
	MdOutlineLaptop,
	MdOutlineBuild,
	MdOutlinePhotoCamera,
	MdOutlineChair,
	MdDraw,
	MdOutlineChatBubbleOutline,
	MdOutlineDeveloperBoard,
	MdOutlineHome,
	MdOutlineLightbulb,
	MdOutlineRemoveRedEye,
	MdOutlinePushPin,
	MdOutlineLock,
	MdOutlineCheckCircle,
	MdOutlineArrowBackIosNew,
	MdOutlineEmojiEvents,
	MdOutlineStar,
	MdOutlinePerson,
	MdOutlineAdd,
	MdOutlineFavoriteBorder,
	MdOutlineWorkspacePremium,
	MdOutlineFormatListBulleted,
	MdOutlineClose,
	MdOutlineWarning,
	MdOutlineVerifiedUser,
	MdOutlineStorage,
	MdOutlineCookie,
	MdDirectionsCar,
	MdWeekend,
	MdMemory,
	MdOutlineTune,
	MdOutlinePark,
} from "react-icons/md";

export const iconMap: Record<
	string,
	React.ComponentType<{ className?: string }>
> = {
	// Existing Icons from ForumCategoryList.tsx
	"wrench": MdOutlineBuild,
	"chat": MdOutlineChatBubbleOutline,
	"cpu": MdOutlineDeveloperBoard,
	"phone": MdOutlineSmartphone,
	"home": MdOutlineHome,
	"bulb": MdOutlineLightbulb,

	// New Icons from user's request
	"car": MdDirectionsCar,
	"couch": MdWeekend,
	"laptop": MdOutlineLaptop,
	"microchip": MdMemory,
	"mixer": MdOutlineTune,

	// Aliases for user's SVG names if they are different from the key
	"house-chimney": MdOutlineHome, // Mapping house-chimney.svg to existing HomeIcon
	"mobile-hand": MdOutlineSmartphone, // Mapping mobile-hand.svg to existing DevicePhoneMobileIcon
	"leaf": MdOutlinePark, // For gardening/outdoor category

	// Default fallback icon
	"default": MdDraw,
};

// Admins configuration
export const ADMIN_CONFIG = {
	emails: ["nirhhhh@gmail.com"] as string[], // e.g. ["you@example.com"]
	uids: [] as string[],
};

// Deprecate CATEGORY_ICONS as iconMap will serve as the centralized icon source
// export const CATEGORY_ICONS: {
// 	[key: string]: React.ComponentType<{ className?: string }>;
// } = {
// 	c1: MdOutlineSmartphone,
// 	c2: MdOutlineLaptop,
// 	c3: MdOutlineBuild,
// 	c4: MdOutlinePhotoCamera,
// 	c5: MdOutlineChair,
// 	default: MdDraw,
// };
